import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";
import { typographyScale } from "../../tokens";

const VARIANT_CLASS = {
  display: styles.heading,
  h1: styles.heading,
  h2: styles.heading,
  h3: styles.heading,
  title: styles.text,
  subtitle: styles.text,
  body: styles.text,
  small: styles.text,
  caption: styles.text,
  label: styles.text,
  mono: styles.text,
  numeric: styles.heading,
};

const TAG = {
  display: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  title: "p",
  subtitle: "p",
  body: "p",
  small: "p",
  caption: "p",
  label: "span",
  mono: "code",
  numeric: "span",
};

export default function TRAText({ as, variant = "body", className, style, children, ...rest }) {
  const v = typographyScale[variant] ? variant : "body";
  const Component = as || TAG[v] || "p";
  const tokenStyle = {
    fontSize: `var(--tra-font-${v}-size)`,
    lineHeight: `var(--tra-font-${v}-line-height)`,
    fontWeight: `var(--tra-font-${v}-weight)`,
    letterSpacing: typographyScale[v]?.letterSpacing,
    fontFamily:
      v === "mono"
        ? "var(--tra-font-family-mono)"
        : v === "numeric" || v.startsWith("h") || v === "display"
          ? "var(--tra-font-family-display)"
          : "var(--tra-font-family-body)",
    ...style,
  };
  return (
    <Component className={cn(VARIANT_CLASS[v], className)} style={tokenStyle} {...rest}>
      {children}
    </Component>
  );
}

export function TRAHeading(props) {
  return <TRAText {...props} />;
}
